import {NamaPresenter} from "./NamaPresenter";
import * as metadata from "../common/Metadata";
import {findActionsWithActionId, findFieldMetadata} from "../common/Metadata";
import * as editLayout from "../views/edit/EditScreenLayout";
import {setHeightOfToolBar} from "../views/edit/EditScreenLayout";
import * as cmn from "../common/NamaCommon";
import {
    addWaitImmediate,
    ajaxJSON,
    ajaxJSONWithoutError,
    areEqual,
    busy,
    fieldValue,
    isAnyEqualToFirst,
    isAnyTrue,
    isEmptyOrNull,
    isNotEmptyOrNull,
    isNullOrUndefined,
    registerOnWindowResize,
    removeWait,
    requestToUrlString
} from "../common/NamaCommon";
import * as ViewMode from "../constants/ViewMode";
import * as CommonConstants from "../constants/CommonConstants";
import * as CommonFieldIds from "../constants/CommonFieldIds";
import * as navigationType from "../constants/NavigationType";
import * as NamaURLS from "../constants/NamaURLS";
import * as DocumentFileStatus from "../constants/DocumentFileStatus";
import * as ApplicableWhen from "../constants/ApplicableWhen";
import * as ApprovalCaseState from "../constants/ApprovalCaseState";
import * as GenerationType from "../constants/GenerationType";
import * as TransactionRequestStatus from "../constants/TransactionRequestStatus";
import {NamaRouterInstance} from "./NamaRouter";
import {EditPlace, EntityListPlace} from "./places";
import * as notifier from "../common/ErrorsNotification";
import {findFieldAndHighLightIt} from "../common/ErrorsNotification";
import * as trans from "../common/Translator";
import * as Translator from "../common/Translator";
import {
    isArabic,
    translateId,
    translateIdAr,
    translateIdEn,
    translateNaMaTextAr,
    translateNaMaTextEn,
    translateTitledId
} from "../common/Translator";
import {
    findEntityMaxReviseCount,
    getCodeSateLiteFields,
    getCustomGUISettings,
    getEntityTemplates,
    getMenuLineBySrc,
    isDocument,
    isFeatureEnabled,
    isPrintingPossible,
    nextGUIDId
} from "../login/ClientCache";
import {areTwoObjectsEqual} from "../common/ObjectComparator";
import {getPageAuthority, userCanCreate, userCanEdit} from "../login/Security";
import {
    addContextFieldsToMap,
    collectFieldsFromParameterMapping,
    createSearchContextInfo,
    performPostAction,
    performPreValidation,
    validateField
} from "../actions/BaseDispatcher";
import {ApproveEditScreen} from "../views/edit/ApproveEditScreen";
import {initTreeViewForEditing, isInNewMode, prevalidateToolbarButtons} from "../views/edit/EditScreenToolbar";
import {ActionHandler} from "../widgets/ActionHandler";
import {of} from "../widgets/ActionPlaceholder";
import {GuiActionPerformer} from "../widgets/GuiActionPerformer";
import {modelId, NamaGridWidget} from "../grid/NamaGridWidget";
import * as PrintingOption from "../constants/PrintingOption";
import {getDirectPrintOption, printForm, titleToParam} from "../common/NaMaPrinting";
import * as DownloadPurpose from "../constants/DownloadPurpose";
import {EmailSenderView} from "../views/EmailSenderView";
import * as RepOutputFormat from "../constants/RepOutputFormat";
import * as PreferencesRequest from "../constants/PreferencesRequest";
import * as OwnerType from "../constants/OwnerType";
import * as placeTokens from "../constants/PlaceTokens";
import {hasParentEntity} from "../views/treeView/TreeViewForListView";
import {startTermOrConfigEntryEditScreen} from "../views/edit/TermScreenLayout";
import * as DomainBaseEntities from "../constants/DomainBaseEntities";
import {FieldValuesSetter} from "../common/FieldValuesSetter";
import {NamaKendoWindow, NamaWindowBtnData} from "../views/NamaKendoWindow";
import * as BusinessFunction from "../constants/BusinessFunction";
import {getMoreMenuItems} from "../views/edit/EditScreenMoreMenu";
import * as OutputFormat from "../constants/OutputFormat";
import {EmbeddedListView} from "../views/edit/EmbeddedListView";
import {CriteriaExpressionSerializer, QuestionFieldsSerializer} from "../common/CriteriaAndQuestionsURLParser";
import * as DomainBaseFieldIDs from "../constants/DomainBaseFieldIDs";
import {currentUserSettings} from "../login/LoginPresenter";
import {calcMainFileID, mainFileImgTag} from "../common/AttachmentLinkUtil";
import * as ShowImageIn from "../constants/ShowImageIn";
import {createGenericValueForType} from "../actions/GenericValues";
import * as FieldType from "../constants/FieldType";
import * as GenericActions from "../constants/GenericActions";
import * as DTOSecurityFieldAuthority from "../constants/DTOSecurityFieldAuthority";
import {fillSearchDataInFieldSearchSuggestionItem} from "../widgets/TopPanelSearchSuggestOracle";
import {appendRow} from "../grid/GridEventsController";
import {stringify} from "../common/NamaJSON";
import {isMobileDevice} from "../common/GUIUtilities";
import {calcByLanguage} from "../views/treeView/TreeModelProvider";

export function attachNextAndPreviousFocus(editLayoutWrapper, doNotFocusFirstInput) {
    let inputs = editLayoutWrapper.find(":input:enabled:visible,.enabledDropDown, .k-numeric-wrap>:input:enabled, .k-numerictextbox>:input:enabled").not(':button');
    if (!doNotFocusFirstInput)
        if (inputs && inputs[0]) setTimeout(() => inputs[0].focus(), 500);
    inputs.on("keyup", (e) => {
        if (e.ctrlKey || e.altKey)
            return;
        if (e.keyCode === kendo.keys.ENTER) {
            e.preventDefault();
            e.stopPropagation();
            let currentInputIndex = inputs.index(e.target);
            if (e.shiftKey) {
                if (currentInputIndex === 0)
                    $(inputs[inputs.length - 1]).focus();
                else
                    $(inputs[currentInputIndex - 1]).focus();
            } else {
                if (currentInputIndex === inputs.length - 1)
                    $(inputs[0]).focus();
                else
                    $(inputs[currentInputIndex + 1]).focus();
            }

        }
    });
}

export function collapseItemIfNeeded(item) {
    let element = $(item);
    let id = element.attr("collapseId");
    if (!id)
        return;
    let body = element.parent().find(".info-body");
    let arrow = element.find("i.fa-angle-up");
    let forceToggle = false;
    let mustCollapse = localStorage.getItem(id);
    if (id.endsWith("defaultCollapseKey") && mustCollapse == "false")
        forceToggle = true;
    if (forceToggle || (mustCollapse == "true" && !arrow.hasClass("rotate"))) {
        element.trigger("click");
    }
}

/**
 * @implements {FiledsOwner}
 */
export class EditPresenter extends NamaPresenter {
    constructor(place) {
        super(place);
        let that = this;
        that._pageIndex = parseInt(place.pageId);
        if (isNaN(that._pageIndex)) {
            that._pageIndex = 0;
            place.doSet(placeTokens.PRM_PAGE_ID, "0");
            that.updateURl(place);
        }
        that.dataWidgets = new Map();
        let currentPresenter = NamaRouterInstance.currentPresenter;
        if (currentPresenter.getOrderBy)
            that.sortBy = currentPresenter.getOrderBy();
        this.changeListeners = {};
    }

    onFieldChanged(fieldId) {
        let listeners = this.changeListeners[fieldId];
        if (!listeners)
            return;
        for (let listener of listeners) {
            if (listener)
                listener(fieldId);
        }
    }

    addOnChangeListener(fieldIds, listener) {
        let fields = [];
        if (fieldIds.length)
            fields = fieldIds;
        else if (fieldIds.p1)
            fields = collectFieldsFromParameterMapping(fieldIds);
        for (let field of fields) {
            if (!field || !field.length)
                continue;
            let listeners = this.changeListeners[field];
            if (!listeners)
                listeners = [];
            listeners.push(listener);
            this.changeListeners[field] = listeners;
        }
    }

    autoSave(focusFieldAfterAutoSave, addLineToGridAfterAutoSave, saveBehaviour) {
        this.doSaveRecord([], saveBehaviour, (saveSucceeded) => {
            let that = this;
            if (!saveSucceeded)
                return;
            /***
             *
             * @type {NamaGridWidget}
             */
            let grid = null;
            let fieldsWithId = that.getFieldsWithId(addLineToGridAfterAutoSave);
            if (addLineToGridAfterAutoSave && isNotEmptyOrNull(fieldsWithId)) {
                grid = fieldsWithId[0];
                appendRow(grid.kendoGrid(), true, grid, false).then(() => that.focusFieldOrCell(focusFieldAfterAutoSave));
            } else {
                that.focusFieldOrCell(focusFieldAfterAutoSave);
            }
        });
    }

    focusFieldOrCell(focusFieldAfterAutoSave) {
        if (!focusFieldAfterAutoSave)
            return;
        let that = this;
        let fieldsWithId = that.getFieldsWithId(focusFieldAfterAutoSave);
        if (fieldsWithId && fieldsWithId.length) {
            fieldsWithId[0].focus();
            return;
        }
        let grid = that.getGrid(focusFieldAfterAutoSave);
        if (!grid)
            return;
        grid.focusColumnInLastRow(focusFieldAfterAutoSave);
    }

    updateURl(place) {
        let that = this;
        if (that.place.quickCreate || that.place.simpleEntityView)
            return;
        NamaRouterInstance.updateHistoryURLSilently(place);
    }

    start() {
        /**
         *
         * @type {namaTypes.FetchPreferencesRequest}
         */
        let req = {};
        req.owner = {ownerType: OwnerType.Entity, ownerId: this.entityType};
        req.properties = [PreferencesRequest.EDIT_LAYOUT, PreferencesRequest.META_DATA, PreferencesRequest.LIST_LAYOUT_PREFERENCES];
        let that = this;
        if (that.place.simpleEntityView)
            req.properties = [PreferencesRequest.EDIT_LAYOUT, PreferencesRequest.META_DATA];
        req.editLayoutScreenName = that.viewName_();
        req.listLayoutScreenName = that.place.listViewName;
        metadata.fetchPreferences(req, (preferences) => {
            this.preferences = preferences;
            this.startEditView();
        });
    }

    async startEditView() {
        let that = this;
        let editLayoutWrapper = $(`<div id="example" class="page-content-wrapper"></div>`);
        if (!that.simpleEntityContainer) {
            $("#main-wrapper").find("#example.page-content-wrapper").remove();
            editLayoutWrapper.appendTo("#main-wrapper");
        } else
            editLayoutWrapper = that.simpleEntityContainer;

        that.view = editLayout.drawEditScreen(editLayoutWrapper, that);
        addWaitImmediate();
        for (let [page, dataWidgets] of that.dataWidgets) {
            for (let widget of dataWidgets) {
                widget.afterAttach(that.view);
            }
        }
        removeWait();
        that.tabStrip = editLayoutWrapper.find("#tabstrip").data("kendoTabStrip");
        if (!that.isConfigEntryOrTermScreen()) {
            that.selectPageAndFocusOnFieldIfNeeded();
        }
        setTimeout(() => {
            that.fetchFromServer();
        });
        let splitter = that.view.find("#splitter");
        initTreeViewForEditing(splitter, that);
        if (that.place.simpleEntityView) {
            editLayoutWrapper.find("#tabstrip").find(".title").remove();
            editLayoutWrapper.find(".quick-icons-one-invoice").remove();
            editLayoutWrapper.find("#tabstrip").find(".k-tabstrip-items-wrapper").remove();
        } else {
            setHeightOfToolBar(editLayoutWrapper);
        }
    }

    isConfigEntryOrTermScreen() {
        return this.entityType === DomainBaseEntities.DocumentTerm || this.entityType === DomainBaseEntities.ConfigEntry;
    }

    selectPageAndFocusOnFieldIfNeeded() {
        let that = this;
        that.tabStrip.select(that.place.pageId);
        if (that.place.focusOnField) {
            let item = that.calcPresenterFields().filter((e) => e.id === that.place.focusOnField);
            if (item.length)
                item = item[0];
            else
                return;
            let widget = item.widget.elementToHighlight ? item.widget.elementToHighlight() : item.widget;
            findFieldAndHighLightIt(that.place.focusOnField, -1, this, item.pageIndex, widget);
        }
    }

    docTypeSelectedInTerm() {
        let that = this;
        let docTypeField = that.getFieldsWithId("documentType")[0];
        let docType = docTypeField.findElement().data("kendoDropDownList").value();
        if (!docType)
            return;
        startTermOrConfigEntryEditScreen(that, docType);
    }

    fetchFromServer() {
        let that = this;
        if (that.place.reNavigateToObject) {
            let createdObject = that.place.reNavigateToObject;
            that.place.reNavigateToObject = undefined;
            that.editRecord(createdObject);
        } else if (that.place.createdObject) {
            let createdObject = that.place.createdObject;
            that.editRecord(createdObject);
        } else if (that.isNew) {
            that.createNew();
        } else {
            that.findByIdOrCode();
        }
    }

    createNew(shortCutTemplateId) {
        let that = this;
        if (!that.place.templateId) {
            let menuLine = getMenuLineBySrc(that.place.src);
            if (menuLine && menuLine.target && menuLine.target.defaultsTemplate && menuLine.target.defaultsTemplate.id)
                that.place.templateId = menuLine.target.defaultsTemplate.id;
        }
        cmn.ajaxJSON(NamaURLS.CREATE_NEW, {
            entityType: that.entityType,
            wholeObject: JSON.stringify(that.getObject()),
            templateId: that.place.templateId || shortCutTemplateId
        }, (result) => {
            let record = result.data;
            that.place.view = ViewMode.NEW;
            that.place.id = "";
            that.editRecord(record, true);
            that.updateURl(that.place);
        });
    }

    findByIdOrCode() {
        let that = this;
        cmn.ajaxJSON(NamaURLS.FIND_BY_ID, {
            entityType: that.entityType,
            id: that.id,
            version: that.place.version,
            findDraft: true
        }, (result) => {
            let record = result.data;
            that.place.view = ViewMode.EDIT;
            that.editRecord(record);
        });
    }

    async editRecord(record, updateHistory) {
        let that = this;
        that.record = record;
        that.view.find(".page-top-header-name").text(that.getTitleDescription);
        let createRequester = that.place.quickCreateRequester;
        if (that.record && isInNewMode(that) && isNotEmptyOrNull(createRequester)) {
            if (isAnyEqualToFirst(that.entityType, DomainBaseEntities.DocumentBook, DomainBaseEntities.DocumentTerm)
                && isEmptyOrNull(that.record.documentType))
                that.record.documentType = createRequester;
            else if (isAnyEqualToFirst(that.entityType, DomainBaseEntities.MasterGroup, DomainBaseEntities.DocCategory) && isEmptyOrNull(that.record.forType))
                that.record.forType = createRequester;
        }
        if (that.redirectPlaceIfDifferentEditViewOrMenu())
            return;
        if (record.entityType === DomainBaseEntities.DocumentTerm) {
            if (record.termConfigStr)
                record.termConfig = JSON.parse(record.termConfigStr);
            await startTermOrConfigEntryEditScreen(that, record.documentType);
        } else if (record.entityType === DomainBaseEntities.ConfigEntry) {
            if (record.valueStr)
                record.value = JSON.parse(record.valueStr);
            await startTermOrConfigEntryEditScreen(that, record.propertyName, true);
        }
        for (let [page, dataWidgets] of that.dataWidgets) {
            for (let widget of dataWidgets) {
                if (widget instanceof NamaGridWidget) {
                    let fieldId = widget.id;
                    let fieldValue = that.getFieldValue(fieldId);
                    if (!fieldValue)
                        fieldValue = [];
                    if (!fieldValue.length) {
                        fieldValue.push({id: await nextGUIDId()});
                        widget._kendoGrid().dataSource.page(0);
                    }
                    that.setFieldValue(fieldId, fieldValue);
                }
            }
        }
        that.clone = $.extend(true, {}, record);

        if (updateHistory && that.place.view !== ViewMode.NEW) {
            that.place.view = ViewMode.EDIT;
            that.place.id = record.id;
            that.updateURl(that.place);
        }
        if (that.place.view === ViewMode.NEW && isNotEmptyOrNull(that._templateFieldCallerName)) {
            let field = that.getFieldsWithId(that._templateFieldCallerName);
            field[0].setValue(that._templateFieldCallerValue);
            validateField(field[0], null, that);
            that._templateFieldCallerName = null;
            that._templateFieldCallerValue = null;
        }
        if (that.place.view === ViewMode.NEW && that.place.fields)
            new FieldValuesSetter(that.place.fields, that).start();
        that.bindDataWidgets();
        that.removeErrorsMarkerIfExist();
        let toolbar = that.container.find(".toolbar");
        if (that.simpleEntityContainer && !that.place.quickCreate) {
            let topHeader = that.simpleEntityContainer.find(".page-top-header");
            topHeader.remove();
        } else {
            prevalidateToolbarButtons(toolbar, that);
        }
        let mainFileContainer = that.view.find("#mainFileContainer");
        if (mainFileContainer && mainFileContainer.length) {
            mainFileContainer.find(".employee-img").remove();
            mainFileContainer.prepend(mainFileImgTag(that.entityType, calcMainFileID(that.record), ShowImageIn.HeaderFields, that.id, false, mainFileContainer, true, that.record));
        }
        that.preValidateCurrentPage();
        that.collapseGroupsIfNeeded();
        let editLayoutWrapper = that.view;
        attachNextAndPreviousFocus(editLayoutWrapper);
        if (!that.place.simpleEntityView)
            setHeightOfToolBar(that.view);
        registerOnWindowResize(that.view, (e) => {
            setHeightOfToolBar(that.view);
        });
    }

    collapseGroupsIfNeeded() {
        let presenter = this;
        let groups = presenter.view.find("#tabstrip");
        let panelItems = $(groups).find(".toggle-info");
        for (let item of panelItems) {
            collapseItemIfNeeded(item);
        }
    }

    panelBarItemKey(itemId) {
        let presenter = this;
        return presenter.entityType + CommonConstants.SEPARATOR + presenter.viewName_() + CommonConstants.SEPARATOR + itemId + CommonConstants.SEPARATOR + presenter._pageIndex + CommonConstants.SEPARATOR + "collapse";
    }


    redirectPlaceIfDifferentEditViewOrMenu() {
        let that = this;
        if (!getCustomGUISettings().shouldRedirectEditView)
            return false;
        if (that.place.quickCreate)
            return false;
        let customViewName = that.record.customViewName;
        if (customViewName) {
            let parts = customViewName.split(";");
            let viewName = parts[0];
            let menu = "";
            if (parts.length > 1)
                menu = parts[1];
            let place = new EditPlace({parentPlace: that.place, copyFromPlace: true});
            place.id = that.place.id;
            let shouldRedirect = false;

            if (viewName && (viewName !== place.calcEditViewName())) {
                shouldRedirect = true;
                place.listViewName = viewName;
                if (place.editViewName)
                    place.editViewName = viewName;
                place.reNavigateToObject = that.record;
            }
            if (menu && (menu !== place.src)) {
                shouldRedirect = true;
                place.src = menu;
                place.reNavigateToObject = that.record;
            }
            if (shouldRedirect) {
                NamaRouterInstance.goTo(place);
                return true;
            }
        }
        return false;
    }

    removeErrorsMarkerIfExist() {
        for (let [page, dataWidgets] of this.dataWidgets) {
            for (let widget of dataWidgets) {
                widget.removeErrorMarkerAndTooltip();
            }
        }
    }

    bindDataWidgets() {
        let dataWidgets = this.dataWidgets.get(this.currentPageIndex);
        for (let widget of dataWidgets) {
            widget.setValue(cmn.fieldValue(this.record, widget.id));
        }
    }

    getFieldValue(fieldId, row) {
        return cmn.fieldValue(this.record, fieldId, row)
    }

    setFieldValue(fieldId, value, row) {
        return cmn.setFieldValue(this.record, fieldId, value, row)
    }

    //region Getters and Setters
    get id() {
        return this.place.id || this.record.id;
    }

    get code() {
        return this.record.code;
    }

    get isNew() {
        return this.place.view === ViewMode.NEW;
    }

    get isView() {
        return this.place.view === ViewMode.VIEW;
    }

    get entityType() {
        return this.record.entityType || this.place.entityType;
    }

    get getTitleDescription() {
        if (this.isNew)
            return translateId('addNew') + " " + this.getDetailsViewTitlePrefix(this.entityType, getMenuLineBySrc(this.place.src))
        let description = this.getEditViewTile();
        let currentState = this.getCurrentState();
        let title = this.getText(this.record["arabicTitle"], this.record["englishTitle"], trans.isArabic());
        if (title) {
            if (!currentState)
                currentState = title;
            else currentState = currentState + " - " + title
        }
        if (currentState)
            description += ' (' + currentState + ')';
        return description;
    }

    getCurrentState() {
        let obj = this.record;
        let status = "";
        if (obj) {
            let generationType = this.findGenerationType();
            if (generationType && generationType === GenerationType.NotGenerated
                && generationType !== GenerationType.GeneratedEditable) {
                status += trans.translateId('GenerationType.' + generationType);
            }
            let addedRequestsStatus = false;
            /**
             * @type {namaTypes.DTODocumentRequestStatuses}
             */
            let requests = obj[CommonFieldIds.REQUESTS];
            if (requests) {
                let requestsStatuses = requests.statuses;
                if (requestsStatuses && requestsStatuses.list) {
                    for (let requestStatus of requestsStatuses.list) {
                        let currentLineStatus = requestStatus["status"];
                        if (cmn.areNotEqual(currentLineStatus, TransactionRequestStatus.Processed)) {
                            if (status)
                                status += " - ";
                            status += translateId('TransactionRequestStatus.' + currentLineStatus);
                            addedRequestsStatus = true;
                            break;
                        }
                    }
                }
            }

            if (!addedRequestsStatus) {
                let documentFileStatus = this.record[CommonFieldIds.DOCUMENT_FILE_STATUS];
                if (documentFileStatus) {
                    if (status)
                        status += " - ";
                    status += trans.translateId('DocumentFileStatus.' + documentFileStatus);
                    if (this.record[CommonFieldIds.DRAFT_CREATED]) {
                        status += " - ";
                        status += trans.translateId('DocumentFileStatus.' + DocumentFileStatus.Draft);
                    }
                } else if (this.isApprovalPending()) {
                    if (status)
                        status += " - ";
                    status += trans.translateId('ApprovalCaseState.' + ApprovalCaseState.InProgress);
                } else if (this.record[CommonFieldIds.DRAFT_CREATED]) {
                    if (status)
                        status += " - ";
                    status += trans.translateId('DocumentFileStatus.' + DocumentFileStatus.Draft);
                }
            }
            if (this.isRevised()) {
                if (status)
                    status += " - ";
                status += trans.translateId('revised');
                let reviseLevel = this.fetchDisplayLevel();
                if (reviseLevel)
                    status += " - " + trans.translateId(reviseLevel);
            }
            if (this.isUsagePrevented()) {
                if (status)
                    status += " - ";
                status += trans.translateId('usagePrevented');
            }
        }
        return status;
    }

    get record() {
        if (!this._record)
            this._record = {};
        return this._record;
    }

    set record(record) {
        this._record = record;
    }

    /**
     *
     * @returns {namaTypes.EditScreenLayout}
     */
    get editLayout() {
        if (this.place.quickCreate && this.preferences.editLayout && this.preferences.editLayout.quickCreatorScreen)
            return this.preferences.editLayout.quickCreatorScreen;
        if (isMobileDevice() && this.preferences.editLayout && this.preferences.editLayout.mobileScreen)
            return this.preferences.editLayout.mobileScreen;
        return this.preferences.editLayout;
    }

    get metadata() {
        if (!this.preferences)
            return {};
        return this.preferences.metaData;
    }

    get metaData() {
        return this.preferences.metaData;
    }

    get currentPageIndex() {
        return this._pageIndex;
    }

    //endregion

    addDataWidget(widget) {
        this.dataWidgets.get(this.currentlyDrawingPage).push(widget)
    }

    getPageContainsWidget(widgetId) {
        for (let [page, dataWidgets] of this.dataWidgets) {
            for (let widget of dataWidgets) {
                if ((widget.isGridWidget && widget.containsColumn(widgetId)) || widgetId === widget.id)
                    return page;
            }
        }
        return -1;
    }

    setDrawingPageIndex(pageIndex) {
        this.currentlyDrawingPage = pageIndex;
        this.dataWidgets.set(pageIndex, []);
    }

    onDataChanged(id, value) {
        cmn.setFieldValue(this.record, id, value);
        performPostAction(this, id, value)
    }

    rootElement() {
        return this.view;
    }

    onPageChanged(newPageIndex) {
        let that = this;
        let oldPageIndex = that._pageIndex;
        that._pageIndex = newPageIndex;
        that.place.doSet(placeTokens.PRM_PAGE_ID, newPageIndex + "");
        that.updateURl(that.place);
        setTimeout(() => {
            that.bindDataWidgets();
            that.preValidateCurrentPage();
            if (oldPageIndex != newPageIndex)
                that.collapseGroupsIfNeeded();
        })
    }

    navigationNotConfirmed(...fieldsToIgnore) {
        if (this.hasChanges(fieldsToIgnore)) {
            if (!window.confirm(translateId("areYouToNavigate")))
                return true;
        }
        return false;
    }

    canNavigate() {
        if (this.hasChanges())
            return {canNavigate: false, msg: translateId("areYouToNavigate")};
        return super.canNavigate();
    }

    hasChanges(fieldsToIgnore) {
        let that = this;
        if (!that.clone)
            return false;
        return !areTwoObjectsEqual(that.record, that.clone, that.metadata, fieldsToIgnore);
    }

    errorIfHasChanges() {
        if (!this.hasChanges())
            return false;
        notifier.showError(translateId("actionModifiedEntity"))
        return true;
    }

    //region Toolbar Buttons Code
    onListView() {
        let that = this;
        let listPlace = new EntityListPlace({parentPlace: that.place, copyFromPlace: true});
        listPlace.entityType = that.entityType;
        listPlace.extraCriteria = that.place.extraCriteria;
        NamaRouterInstance.goTo(listPlace);
    }

    onNewRecord(shortCutTemplateId, ignoreConfirmation) {
        let that = this;
        if (!ignoreConfirmation && that.navigationNotConfirmed())
            return;
        that.place.view = ViewMode.NEW;
        that.place.id = "";
        that.place.fields = "";
        that.place.templateId = shortCutTemplateId;
        that.createNew(shortCutTemplateId);
    }

    saveRecord(confirmations) {
        let that = this;
        if (that.popUpQuickCreator)
            that.popUpQuickCreator.okAction();
        else
            that.doSaveRecord(confirmations, NamaURLS.SAVE_AND_COMMIT)
    }

    doSaveRecord(confirmations, url, callback) {
        let that = this;
        that.saveWrapper(confirmations, () => {
            if (that.place.view !== ViewMode.NEW && !that.hasChanges() && !that.record.draftCreated) {
                notifier.showError(translateId("noChangesToSave"))
                return;
            }
            that.prepareDataBeforeSave();
            cmn.ajaxJSON(url + '&' + requestToUrlString({
                entityType: that.entityType,
                confirmations: stringify(confirmations)
            }), JSON.stringify(that.record), (result) => {
                let record = result.data;
                that.showRecordSavedMsg();
                that.place.view = ViewMode.EDIT;
                if (url === NamaURLS.SAVE_AND_COMMIT)
                    that.printOnSave();
                that.editRecord(record, true);
                if (callback)
                    callback(that);
            }, (args) => that._saveFailureCallBack(args, (confirmations) => that.doSaveRecord(confirmations, url)), that, true);
        });
    }

    saveDraft(confirmations) {
        this.doSaveRecord(confirmations, NamaURLS.SAVE_DRAFT);
    }

    printOnSave() {
        let that = this;
        if (!isDocument(that.entityType))
            return;
        let book = that.record.book;
        let printOnSave = book && book.extraData[DomainBaseFieldIDs.DocumentBook_printOnSave];
        printOnSave = printOnSave || currentUserSettings().printDocumentsOnSave;
        if (printOnSave) {
            if (isNullOrUndefined(that.record.currentVersion) || that.record.currentVersion < 2)
                that.onPrint(OutputFormat.PDF, true);
        }
    }

    prepareDataBeforeSave() {
        let that = this;
        if (that.entityType === DomainBaseEntities.DocumentTerm) {
            that.record.termConfigStr = JSON.stringify(that.record.termConfig);
        } else if (that.entityType === DomainBaseEntities.ConfigEntry) {
            that.record.valueStr = JSON.stringify(that.record.value);
        }
    }

    showRecordSavedMsg() {
        notifier.showSuccess(trans.translateId("recordSavedCorrectly"));
    }

    showOperationSuccessfullMsg() {
        notifier.showSuccess(trans.translateId("operationSuccessfull"));
    }

    _saveFailureCallBack(args, callBack) {
        if (!args || !args.confirmations)
            return;
        this.confirm(args.confirmations, callBack);
    }

    confirm(confirmations, callBack) {
        let window = new NamaKendoWindow("confirmBeforeStarting", new NamaWindowBtnData("ok", () => {
            window.closeWindow();
            for (let confirm of confirmations) {
                confirm.confirmed = true;
            }
            callBack(confirmations);
        }), new NamaWindowBtnData("cancel"));
        let content = '<ol>';
        for (let confirm of confirmations) {
            content += `<li style="font-weight: bold">${calcByLanguage(confirm.message.arabicText, confirm.message.englishText)}</li>`;
        }
        content += '</ol>';

        window.content.append(content);
        window.showWindow();
    }

    saveWrapper(confirmations, saveCallBack) {
        let that = this;
        if (busy()) {
            setTimeout(() => that.saveWrapper(confirmations), 10);
            return;
        }
        $(':focus').blur();
        $(".k-editor").find(".k-textbox").blur()
        setTimeout(() => saveCallBack(), 10);
    }

    onRefresh() {
        if (this.navigationNotConfirmed())
            return;
        this.fetchFromServer();
    }

    saveQuickCreatedObject(successCallback, confirmations) {
        let that = this;
        that.prepareDataBeforeSave();
        cmn.ajaxJSON(NamaURLS.SAVE_AND_COMMIT + '&' + requestToUrlString({
            entityType: that.entityType,
            confirmations: stringify(confirmations)
        }), JSON.stringify(that.record),
            (result) => {
                let record = result.data;
                that.showRecordSavedMsg();
                if (successCallback)
                    successCallback(record);
            }, (args) => that._saveFailureCallBack(args, (confirmations) => that.saveQuickCreatedObject(successCallback, confirmations)), that, true);
    }

    saveAndContinue(confirmations) {
        let that = this;
        that.saveWrapper(confirmations, () => {
            if (that.place.view !== ViewMode.NEW && !that.hasChanges() && !that.record.draftCreated) {
                notifier.showError(translateId("noChangesToSave"))
                return;
            }
            that.prepareDataBeforeSave();
            cmn.ajaxJSON(NamaURLS.SAVE_AND_COMMIT + '&' + requestToUrlString({
                entityType: that.entityType,
                confirmations: stringify(confirmations)
            }), JSON.stringify(that.record), (result) => {
                let record = result.data;
                that.showRecordSavedMsg();
                that.printOnSave();
                setTimeout(() => that.onNewRecord(null, true), 200);
            }, (args) => that._saveFailureCallBack(args, (confirmations) => that.saveAndContinue(confirmations)), that, true);
        });
    }

    performApprove(request) {
        cmn.ajaxJSON(NamaURLS.APPROVE, {request: JSON.stringify(request)}, (record) => {
            this.onRefresh();
            //TODO: event to update approvals counter
        });
    }

    onApprove() {
        let selectorPopup = new ApproveEditScreen(this);
        selectorPopup.showPopup();
    }

    revise() {
        let that = this;
        if (that.errorIfHasChanges())
            return;
        cmn.ajaxJSON(NamaURLS.REVISE, {entityType: that.entityType, id: that.id, revise: true}, (result) => {
            let record = result.data;
            that.showOperationSuccessfullMsg();
            that.editRecord(record, true);
        })
    }

    unRevise() {
        let that = this;
        if (that.errorIfHasChanges())
            return;
        cmn.ajaxJSON(NamaURLS.REVISE, {entityType: that.entityType, id: that.id, revise: false}, (result) => {
            let record = result.data;
            that.showOperationSuccessfullMsg();
            that.editRecord(record, true);
        })
    }

    duplicateRecord() {
        let that = this;
        if (that.errorIfHasChanges())
            return;
        cmn.ajaxJSON(NamaURLS.DUPLICATE, {entityType: that.entityType, id: that.id}, (result) => {
            let record = result.data;
            that.place.view = ViewMode.NEW;
            that.place.id = record.id;
            that.editRecord(record, true);
            that.updateURl(that.place);
        });
    }

    navigatePrevious() {
        this._navigate(navigationType.Previous);
    }

    _navigate(type) {
        let that = this;
        if (that.navigationNotConfirmed())
            return;
        let placeCriteria = null;
        if (that.place.criteria)
            placeCriteria = new CriteriaExpressionSerializer().criteriaFromURL(that.place.criteria).build();
        let placeQuestions = null;
        if (that.place.questions)
            placeQuestions = new QuestionFieldsSerializer().questionsFromURL(that.place.questions).build();
        cmn.ajaxJSON(NamaURLS.NAVIGATE, {
            entityType: that.entityType, id: that.id, type: type,
            orderBy: that.sortBy,
            criteria: JSON.stringify(placeCriteria),
            ascending: that.place.ascending + "",
            extraCriteriaId: that.place.extraCriteria,
            questions: JSON.stringify(placeQuestions),
        }, (resp) => {
            let record = resp.data;
            if (record) {
                that.place.view = ViewMode.EDIT;
                that.editRecord(record, true)
            }
        });
    }

    navigateNext() {
        this._navigate(navigationType.Next);
    }

    navigateLast() {
        this._navigate(navigationType.Last);
    }

    navigateFirst() {
        this._navigate(navigationType.First);
    }

    onDelete() {
        let that = this;
        if (that.errorIfHasChanges())
            return;
        if (deleteNotConfirmed())
            return;
        cmn.ajaxJSON(NamaURLS.DELETE, {entityType: that.entityType, id: that.id, code: that.code}, (record) => {
            if (!record || !record.id)
                that.onListView();
            else
                that.editRecord(record, true)

        }, null, that);
    }

    //endregion
    shouldApplyBookTermGroupTemplate(fieldId) {
        return fieldId !== this._templateFieldCallerName;
    }

    applyTemplate(templateId, fromFieldId) {
        let that = this;
        that._templateFieldCallerName = fromFieldId;
        that._templateFieldCallerValue = cmn.fieldValue(that.record, fromFieldId, -1);
        that.place.templateId = templateId;
        that.place.fields = "";
        that.createNew();
    }

    codeChanged(newCode, codeField) {
        if (!newCode)
            return;
        let that = this;
        if (that.codeSateLiteFields.length) {
            for (let codeSateliteField of that.codeSateLiteFields) {
                let codeSateLiteFieldValue = fieldValue(that.record, codeSateliteField)
                if (codeSateLiteFieldValue)
                    newCode = codeSateLiteFieldValue + CommonConstants.CODE_AND_SATELITE_SEP + newCode;
            }
        }
        ajaxJSONWithoutError(NamaURLS.FIND_REF_BY_CODE, {
            code: newCode, entityType: that.entityType,
            contextInfo: JSON.stringify(createSearchContextInfo("code", -1, that))
        }, (ref) => that.navigateToRef(ref, codeField))
    }

    navigateToRef(ref, ...codeField) {
        let that = this;
        if (!ref || !ref.id)
            return;
        if (ref.id === that.record.id)
            return;
        if (that.navigationNotConfirmed(codeField))
            return;
        ajaxJSON(NamaURLS.FIND_BY_ID, {id: ref.id, entityType: that.entityType}, (result) => {
            let record = result.data;
            that.place.view = ViewMode.EDIT;
            that.editRecord(record, true);
        })
    }

    get codeSateLiteFields() {
        return getCodeSateLiteFields(this.entityType)
    }

    isViewOnlyMode() {
        let that = this;
        return that.isRevised() || that.isNotEditableByApproval() || that.isNotEditableBySystem() || (that.userCanNotEdit() && that.userCanNotCreate()) || that.isCancelled() || that.isPurged() || that.isInPurgePeriod() || that.isPurgeJournal();
    }

    isPurgeJournal() {
        return this.entityType === "PurgeJournal";
    }

    isInPurgePeriod() {
        let fiscalPeriodType = this.getFieldValue(CommonFieldIds.FISCAL_PERIOD + ".extras." + CommonConstants.FISCAL_PERIOD_TYPE_FIELD);
        return fiscalPeriodType === CommonConstants.FISCAL_PERIOD_TYPE_PURGE;
    }

    isCancelled() {
        return this._documentFileStatus() === DocumentFileStatus.Cancelled;
    }

    _documentFileStatus() {
        return this.getFieldValue(CommonFieldIds.DOCUMENT_FILE_STATUS);
    }

    isRevised() {
        return this.getFieldValue(CommonFieldIds.REVISED);
    }

    isPurged() {
        return this.getFieldValue(CommonFieldIds.PURGED);
    }

    preventUseAsFromDoc() {
        return this.getFieldValue(CommonFieldIds.PREVENT_USE_AS_FROMDOC);
    }

    currentVersion() {
        return this.getFieldValue(CommonFieldIds.CURRENT_VERSION);
    }

    isNotEditableBySystem() {
        return this.isGeneratedFinal() || this.isAlwaysViewMode();
    }

    isNotEditableByApproval() {
        let that = this;
        return (that.isApprovalPending() && that.canNotBeModifiedWhileApproval()) || that.isApprovalRejected();
    }

    userCanNotCreate() {
        return userCanCreate(this.entityType);
    }

    userCanNotEdit() {
        return !userCanEdit(this.entityType);
    }

    isAlwaysViewMode() {
        return false;
    }

    isApprovalRejected() {
        return this._documentFileStatus() === DocumentFileStatus.ApprovalRejected
            || (!this.getFieldValue(CommonFieldIds.COMMITE_BEFORE) && this.getFieldValue("currentApprovalCase.state") === ApprovalCaseState.Rejected);
    }

    isUsagePrevented() {
        return this.record[CommonFieldIds.PREVENT_USAGE];
    }

    isApprovalReturned() {
        return this._documentFileStatus() === DocumentFileStatus.ApprovalReturned
            || this.getFieldValue("currentApprovalCase.state") === ApprovalCaseState.Returned;
    }

    isApprovalPending() {
        return this._documentFileStatus() === DocumentFileStatus.ApprovalPending
            || this.getFieldValue("currentApprovalCase.state") === ApprovalCaseState.InProgress;
    }

    isGeneratedFinal() {
        return GenerationType.GeneratedFinal === this.getFieldValue(CommonFieldIds.GENERATION_TYPE);
    }

    clearErrors(fieldId) {
        //TODO
    }

    calcFieldAuthorityMode() {
        if (isAnyTrue(this.record[CommonFieldIds.DRAFT_CREATED]))
            return ApplicableWhen.DraftMode;
        if (this.place.view == ViewMode.NEW)
            return ApplicableWhen.NewMode;
        return ApplicableWhen.UpdateMode;
    }

    isRecordNotSaved() {
        return this.place.view == ViewMode.NEW && this.hasChanges();
    }

    codeSateLiteFieldIds() {
        let fieldIds = [];
        if (areEqual(this.entityType, `DocumentBook`))
            fieldIds.push(`documentType`);
        else if (areEqual(this.entityType, `DocumentTerm`))
            fieldIds.push(`documentType`);
        else if (areEqual(this.entityType, `MasterGroup`))
            fieldIds.push(`forType`);
        return fieldIds;
    }

    /**
     *
     * @param columnId
     * @returns {NamaGridWidget[]}
     */
    getColumnGrids(columnId) {
        let grids = [];
        for (let widget of this.dataWidgets.get(this.currentPageIndex)) {
            if (widget.isGridWidget && widget.containsColumn(columnId))
                grids.push(widget);
        }
        return grids;
    }

    /**
     *
     * @param columnId
     * @return {NamaGridWidget}
     */
    getGrid(columnId) {
        let columnGrids = this.getColumnGrids(columnId);
        return columnGrids ? columnGrids[0] : null;
    }

    getGrids() {
        let grids = [];
        for (let [page, dataWidgets] of this.dataWidgets) {
            for (let widget of dataWidgets) {
                if (widget.isGridWidget)
                    grids.push(widget);
            }
        }
        return grids;
    }

    getColumnGridSelectedRowId(columnId) {
        let grids = this.getColumnGrids(columnId);
        if (!grids || !grids.length)
            return null;
        let selectedRow = grids[0].getSelectedRow();
        if (!selectedRow)
            return null;
        return selectedRow.id;
    }

    getColumnGridSelectedRowIndex(columnId) {
        let grids = this.getGrids().filter(l => columnId.startsWith(l.id + "."));
        if (!grids || !grids.length)
            return null;
        return grids[0].getSelectedIndex();
    }

    getObject() {
        return this.record;
    }

    toReference() {
        let record = this.record || {};
        return {
            entityType: record.entityType,
            id: record.id,
            code: record.code,
            actualCode: record.actualCode,
            altCode: record.altCode,
            name1: record.name1,
            name2: record.name2,
            valueDate: record.valueDate
        }
    }

    getAllVisibleFields() {
        //TODO
        let visibleFields = [];
        for (let [page, dataWidgets] of this.dataWidgets) {
            for (let widget of dataWidgets) {
                visibleFields.push(widget.id);
            }
        }
        return visibleFields;
    }

    /**
     *
     * @returns {namaTypes.DTOApprovalCase}
     */
    currentApprovalCase() {
        return this.record.currentApprovalCase;
    }


    findGenerationType() {
        if (!this.record)
            return null;
        this.record[CommonFieldIds.GENERATION_TYPE];
    }

    getEditViewTile() {
        let obj = this.record;
        let detailsViewTitlePrefix = this.getDetailsViewTitlePrefix(this.entityType, getMenuLineBySrc(this.place.src));
        let code = this.getCode();
        let name = this.getNameForTitles();
        if (name && code !== name)
            code = code + " - " + name;
        if (!obj || !code)
            return detailsViewTitlePrefix;
        return detailsViewTitlePrefix + ' : ' + code;

    }

    /**
     * @param {namaTypes.DTOMenuItem} line
     * @returns {*}
     */
    getDetailsViewTitlePrefix(entityType, line) {
        if (line != null && line.target.targetEntity === entityType && cmn.getFirstNotEmptyObj(line.editViewArTitle, line.editViewEnTitle)) {
            return this.getText(line.editViewArTitle, line.editViewEnTitle, trans.isArabic());
        }
        return trans.translateId(entityType);
    }

    getCode() {
        return this.getText(this.record[CommonFieldIds.CODE], this.record[CommonFieldIds.ALT_CODE], trans.isArabic())
    }

    getName() {
        return this.getText(this.record[CommonFieldIds.NAME1], this.record[CommonFieldIds.NAME2], trans.isArabic())
    }

    getText(arabic, english, isRTL) {
        let word;
        if (isRTL)
            word = (!arabic) ? english : arabic;
        else
            word = (!english) ? arabic : english;
        return word;
    }

    getNameForTitles() {
        let descriptor = this.getText(this.record[CommonFieldIds.DESCRIPTOR1], this.record[CommonFieldIds.DESCRIPTOR2], trans.isArabic());
        let name = this.getName();
        let code = this.getCode()
        return cmn.getFirstNotNullObj(descriptor, name, code, this.record[CommonFieldIds.ID]);
    }

    fetchDisplayLevel() {
        let reviseLevel = this.currentReviseLevelInt();
        let toBeRevisedLevels = findEntityMaxReviseCount(this.entityType).reviseLevel;
        if (reviseLevel == toBeRevisedLevels && toBeRevisedLevels == 1)
            return "";
        return this.toReviseLevel(reviseLevel);
    }

    toReviseLevel(reviseLevel) {
        return 'L' + reviseLevel;
    }

    currentReviseLevelInt() {
        if (this.record !== null && !this.record[CommonFieldIds.REVISELEVEL] && this.isRevised())
            return 1;
        if (this.record === null)
            return 0;
        let levelString = this.record[CommonFieldIds.REVISELEVEL];
        if (!levelString)
            return 0;
        return parseInt(levelString.replace("L", ""));
    }

    getPlaceExtraFieldFilterId() {
        let that = this;
        if (that.place.quickCreate)
            return null;
        let line = getMenuLineBySrc(that.place.src);
        let filterId = null;
        if (line && line.target && line.target.extraFieldFilter)
            filterId = line.target.extraFieldFilter.id;
        return filterId;
    }

    getFieldWithId(row, fieldId) {
        let that = this;
        let hasRow = row != undefined && row != -1;
        let fieldsWithId = that.getFieldsWithId(fieldId);
        if (hasRow && (!fieldsWithId || !fieldsWithId.length)) {
            let grids = that.getColumnGrids(fieldId);
            if (grids && grids.length) {
                return grids[0].fetchCell(row, fieldId);
            }
        }
        if (!fieldsWithId || !fieldsWithId.length) {
            let fieldMetaData = findFieldMetadata(fieldId, that.metaData);
            if (fieldMetaData && fieldMetaData.parentDetail) {
                let parentGrid = that.getFieldsWithId(fieldMetaData.parentDetail.fieldId);
                if (parentGrid.length) {
                    let columns = parentGrid[0].getColumns();
                    if (columns) {
                        for (let col of columns)
                            if (col.id === fieldId)
                                return parentGrid[0].findElement().find("th[data-field='" + modelId(fieldId) + "']");
                    }
                }
            }
            if (that.view.find("li#" + fieldId).length)
                return that.view.find("li#" + fieldId).find(".k-header");
        } else {
            if (fieldsWithId[0].findElement().closest('.form-group').length)
                return fieldsWithId[0].findElement().closest('.form-group');
            if (fieldsWithId[0].findElement().find('.k-grouping-header').length)
                return fieldsWithId[0].findElement().find('.k-grouping-header');
        }
        return that.view.find("#" + fieldId);
    }

    /***
     *
     * @param fieldId
     * @return {BaseWidget[]}
     */
    getFieldsWithId(fieldId) {
        let fields = [];
        let that = this;
        for (let [page, dataWidgets] of that.dataWidgets) {
            for (let widget of dataWidgets) {
                if (widget.id === fieldId)
                    fields.push(widget);
            }
        }
        return fields;
    }

    getFieldsWithIdInCurrentPage(fieldId) {
        let that = this;
        let currentPageFields = that.dataWidgets.get(that.currentPageIndex);
        return currentPageFields.filter(f => f.id === fieldId);
    }

    setAllowedValues(id, value) {
        //TODO:
    }

    getTreeView() {
        return this.view.find("#treeView");
    }

    hasTree() {
        let that = this;
        return that.isShowingTree() && that.supportsTreeViewInEditView();
    }

    supportsTreeViewInEditView() {
        let that = this;
        return hasParentEntity(that.entityType);
    }

    isShowingTree() {
        let that = this;
        return that.place.showTree === "true" || that.place.showTree === true;
    }

    preValidateCurrentPage() {
        let that = this;
        let currentPageFields = [...that.dataWidgets.get(that.currentPageIndex)];
        let currentPage = that.editLayout.pages[that.currentPageIndex];
        let pageAuthority = getPageAuthority(that.entityType, titleToParam(currentPage.title, currentPage.id), that.currentPageIndex);
        if (that.isView)
            pageAuthority = "Disabled";
        performPreValidation(that, currentPageFields, pageAuthority);
        if (that.discussionRecordWidgets)
            that.discussionRecordWidgets.forEach(w => w.preValidate());
    }

    addToDiscussionWidgets(widget) {
        let that = this;
        if (!that.discussionRecordWidgets)
            that.discussionRecordWidgets = [];
        that.discussionRecordWidgets.push(widget);
    }

    callGUIAction(actionId, metaData, actionCustomization) {
        new ActionHandler(of(actionId, actionCustomization), this.entityType, metaData || this.metaData, new GuiActionPerformer()).performAction(this);
    }

    showVersion(versionNumber) {
        let that = this;
        that.place.version = versionNumber;
        setTimeout(() => {
            that.updateURl(that.place);
            that.fetchFromServer();
        });
    }

    addContextFieldsToAction(requester, allContextFieldsIds, row, contextFields,
                             fromGridAction, allSumsIds, sums, presenter) {
        addContextFieldsToMap(requester, allContextFieldsIds, row, contextFields,
            fromGridAction, allSumsIds, sums, presenter);
    }

    onPrint(format, fromPrintButton) {
        let that = this;
        if (that.hasChanges() || isInNewMode(that)) {
            notifier.showError(translateId("printModifiedEntity"));
            return;
        }
        let currentPage = that.editLayout.pages[that.currentPageIndex];
        isPrintingPossible({
                printingOption: PrintingOption.DIALOG, format: format,
                entityType: that.entityType, entityId: that.id, tabId: titleToParam(currentPage.title, currentPage.id),
                viewName: that.editLayout.id, monitorId: null, formReportId: ""
            }, () => printForm(that.entityType, that.id, currentPage.title, format, that.editLayout.id,
                currentPage.id, that.place.src, fromPrintButton)
        )
    }

    sendEmail() {
        let that = this;
        let currentPage = that.editLayout.pages[that.currentPageIndex];
        if (that.hasChanges() || isInNewMode(that)) {
            notifier.showError(translateId("printModifiedEntity"));
            return;
        }
        let format = RepOutputFormat.PDF;
        isPrintingPossible({
            printingOption: PrintingOption.DIALOG, format: format,
            entityType: that.entityType, entityId: that.id, tabId: titleToParam(currentPage.title, currentPage.id),
            viewName: that.editLayout.id, monitorId: null, formReportId: ""
        }, () => sendEmail_(format, that.entityType, that.id, titleToParam(currentPage.title, currentPage.id),
            that.editLayout.id, that.place.src, true, that));
    }


    businessFunctions() {
        let that = this;
        if (that.idsWithActions)
            return that.idsWithActions;
        that.idsWithActions = super.businessFunctions();
        that.idsWithActions[BusinessFunction.save] = () => that.saveRecord();
        that.idsWithActions[BusinessFunction.newRecord] = () => that.onNewRecord();
        that.idsWithActions[BusinessFunction.listView] = () => that.onListView();
        that.idsWithActions[BusinessFunction.saveAndContinue] = () => that.saveAndContinue();
        that.idsWithActions[BusinessFunction.duplicate] = () => that.duplicateRecord();
        that.idsWithActions[BusinessFunction.refresh] = () => that.onRefresh();
        that.idsWithActions[BusinessFunction.revise] = () => that.revise();
        that.idsWithActions[BusinessFunction.unrevise] = () => that.unRevise();
        that.idsWithActions[BusinessFunction.treeView] = () => that.treeView();
        that.idsWithActions[BusinessFunction.first] = () => that.navigateFirst();
        that.idsWithActions[BusinessFunction.previous] = () => that.navigatePrevious();
        that.idsWithActions[BusinessFunction.next] = () => that.navigateNext();
        that.idsWithActions[BusinessFunction.last] = () => that.navigateLast();
        that.idsWithActions[BusinessFunction.$delete] = () => that.onDelete();
        that.idsWithActions[BusinessFunction.more] = () => that.showMoreMenu();
        that.idsWithActions[BusinessFunction.approval] = () => that.onApprove();
        that.idsWithActions[BusinessFunction.exportAsPDF] = () => that.onPrint(OutputFormat.PDF);
        that.idsWithActions[BusinessFunction.exportAsDOCX] = () => that.onPrint(OutputFormat.DOCX);
        that.idsWithActions[BusinessFunction.exportAsRTF] = () => that.onPrint(OutputFormat.RTF);
        that.idsWithActions[BusinessFunction.exportAsXLSX] = () => that.onPrint(OutputFormat.XLSX);
        that.idsWithActions[BusinessFunction.exportAsXLS] = () => that.onPrint(OutputFormat.XLS);
        that.idsWithActions[BusinessFunction.exportAsODT] = () => that.onPrint(OutputFormat.ODT);
        that.idsWithActions[BusinessFunction.exportAsODS] = () => that.onPrint(OutputFormat.ODS);
        that.idsWithActions[BusinessFunction.exportAsPPTX] = () => that.onPrint(OutputFormat.PPTX);
        that.idsWithActions[BusinessFunction.sendEmailWithResult] = () => that.sendEmail();
        that.idsWithActions[BusinessFunction.accept] = () => that.saveDraft();
        return that.idsWithActions;
    }

    hasGUIAction(businessId) {
        let that = this;
        let guiAction = findActionsWithActionId(businessId, that.metaData);
        if (!guiAction) {
            let templates = getEntityTemplates(that.entityType);
            let tempById = templates.filter(t => t.template.id === businessId);
            if (tempById && tempById.length && tempById[0].template) {
                that.place.fields = "";
                that.createNew(tempById[0].template.id);
            }
            return false;
        }
        return !guiAction.contextFields.contains(CommonFieldIds.LIST_VIEW_SELECTED_IDS);
    }

    treeView() {
        let that = this;
        that.place.showTree = !that.isShowingTree();
        let splitter = that.view.find("#splitter");
        initTreeViewForEditing(splitter, that);
    }

    showMoreMenu() {
        let that = this;
        getMoreMenuItems(that);
    }

    calcPresenterFields() {
        let that = this;
        if (!that.cachedFieldsSuggestion)
            that.initPresenterFields();
        return that.cachedFieldsSuggestion;

    }

    initPresenterFields() {
        let that = this;
        let fieldSearchSuggestionItems = [];
        for (let [page, dataWidgets] of that.dataWidgets) {
            for (let widget of dataWidgets) {
                if (!widget.id)
                    continue;
                fieldSearchSuggestionItems.push(that.createFieldSearchSuggestionItem(that.entityType, widget, page));
                if (widget instanceof NamaGridWidget) {
                    that.addGridColumns(fieldSearchSuggestionItems, page, widget);
                }
            }
        }
        fieldSearchSuggestionItems.push(...that.searchableWidgets);
        that.cachedFieldsSuggestion = fieldSearchSuggestionItems;
        return fieldSearchSuggestionItems;
    }

    addGridColumns(fieldSearchSuggestionItems, pageIndex, grid) {
        let that = this;
        for (let i = 0; i < grid.getColumns().length; i++) {
            let column = grid.getColumns()[i];
            that.addWidgetToSearchableWidgets(pageIndex, grid.findElement().find("th[data-field='" + modelId(column.id) + "']"), column, column.id);
        }
    }

    addWidgetToSearchableWidgets(pageIndex, widget, titledId, id) {
        let that = this;
        if (!titledId)
            return;
        that.addToSearchableWidgets({
            widget: widget,
            id: id,
            arabic: translateTitledId(that.entityType, titledId),
            english: translateTitledId(that.entityType, titledId),
            pageIndex: pageIndex,
        });
    }

    addActionBlockToSearchableWidgets(pageIndex, actionBlock, actionBlockElement) {
        let that = this;
        for (let button of actionBlock._actionButtons) {
            that.addWidgetToSearchableWidgets(pageIndex, actionBlockElement.find("#" + button.id), button, button.id);
        }
    }

    addToSearchableWidgets(toAdd) {
        let that = this;
        if (!that.searchableWidgets)
            that.searchableWidgets = [];
        if (!toAdd.id && toAdd.widget)
            that.searchableWidgets.push(that.createFieldSearchSuggestionItem(that.entityType, toAdd.widget, toAdd.pageIndex));
        else
            that.searchableWidgets.push(toAdd);
    }

    gridWithId(gridId) {
        for (let widget of this.dataWidgets.get(this.currentPageIndex)) {
            if (widget.isGridWidget && widget.id === gridId) {
                return widget;
            }
        }
        return null;
    }

    createFieldSearchSuggestionItem(entityType, widget, page) {
        let that = this;
        let fieldSearchSuggestionItem = {};
        fieldSearchSuggestionItem.pageIndex = page;
        fieldSearchSuggestionItem.widget = widget;

        let id = widget.id;
        let english = translateIdEn(entityType + "." + id);
        let arabic = translateIdAr(entityType + "." + id);
        if (widget instanceof EmbeddedListView) {
            let title = widget.block.title;
            if (title) {
                id = title.resourceId;
                english = translateNaMaTextEn(title);
                arabic = translateNaMaTextAr(title);
            }
        }
        fieldSearchSuggestionItem.id = id;
        fieldSearchSuggestionItem.arabic = arabic;
        fieldSearchSuggestionItem.english = english;
        fillSearchDataInFieldSearchSuggestionItem(fieldSearchSuggestionItem);
        return fieldSearchSuggestionItem;
    }

    get cachedFieldsSuggestion() {
        return this.fieldSearchSuggestionItems;
    }

    set cachedFieldsSuggestion(fields) {
        this.fieldSearchSuggestionItems = fields;
    }

    viewName_() {
        return this.place.calcEditViewName();
    }

    layoutPrefix() {
        return "edit";
    }

    place_() {
        return this.place;
    }

    canNotBeModifiedWhileApproval() {
        let allowModifyWhileApproval = this.getFieldValue("currentApprovalCase.allowModifyWhileUnderApproval");
        return isNullOrUndefined(allowModifyWhileApproval) || allowModifyWhileApproval == false;
    }
}

export function isPageHidden(page, entityType, pageIndex) {
    return page == null
        || !userCanAnyFeature(page.relatedtoFeature)
        || areEqual(getPageAuthority(entityType, page.title.resourceId, pageIndex),
            DTOSecurityFieldAuthority.InVisible);
}

function userCanAnyFeature(relatedToFeatures) {
    if (isEmptyOrNull(relatedToFeatures))
        return true;
    for (let feature of relatedToFeatures) {
        if (isFeatureEnabled(feature))
            return true;
    }
    return false;
}

export function sendEmail_(format, entityType, id, titleToParam, layoutId, src, isForm, presenter) {
    let downloadPurpose = DownloadPurpose.PRINT;
    /**
     * @type {namaTypes.LaunchReportRequest}
     */
    let request = {
        questions: "",
        reportId: "",
        outputFormat: format,
        printingOption: getDirectPrintOption(),
        downloadPurpose: downloadPurpose,
        entityType: entityType,
        entityId: id,
        tabId: titleToParam,
        viewName: layoutId,
        isForm: isForm,
        menuCode: src,
        lang: Translator.currentLanguage()
    };
    ajaxJSON(NamaURLS.RunReport, {
        request: JSON.stringify(request)
    }, (result) => {
        let tempPrintIds = $.map(result.list, e => e.tempPrintId);
        if (tempPrintIds) {
            let emailSenderView = new EmailSenderView(presenter);
            emailSenderView.addToExtraFields([{id: "temPrintId", value: tempPrintIds[0]}]);
            emailSenderView.show();
        }
    });
}


export function createTroubleTicketActionHandler(metaData, lastLog, errorList) {
    let helper = {};
    helper.updateRelatedFields = () => {
        return false
    };
    helper.onGuiActionUpdateList = () => {
        return false
    };
    helper.onRefresh = () => {
    };
    helper.entityType =
        DomainBaseEntities.DocumentBook;
    helper.entityMetaData = () => {
        return metaData
    };
    helper.accessor = () => {
        return null
    };
    helper.isRecordNotSaved = () => {
        return false
    };
    helper.addContextFieldsToAction = (requester, contextFieldIds, contextRow, contextFields) => {
        for (let field of contextFieldIds) {
            if (areEqual(field, "currentErrorMessage")) {
                let error = "";
                for (let e of errorList) {

                    if (isArabic())
                        error += e.message.arabicText.trim() + "\n";
                    else
                        error += e.message.englishText + "\n";
                }
                contextFields["currentErrorMessage"] =
                    createGenericValueForType("currentErrorMessage", error, FieldType.Text);
            }
            if (areEqual(field, "lastServerLog")) {
                contextFields["lastServerLog"] = createGenericValueForType("lastServerLog", lastLog, FieldType.Text);
            }
        }

    };
    new ActionHandler(of(GenericActions.CREATE_CRM_TROUBLE_TICKET), "", metaData, new GuiActionPerformer()).performAction(helper);
}

export function deleteNotConfirmed() {
    if (!window.confirm(translateId("yesConfirmDelete")))
        return true;
    return false;
}
